import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface Props {
	error?: boolean;
	success?: boolean;
	driverApp?: boolean;
	width?: string;
}

export const PasswordDescription = styled(Box, {
	shouldForwardProp: (prop) =>
		prop !== 'error' && prop !== 'driverApp' && prop !== 'success',
})<Props>(({ theme, error, width, success }) => ({
	width: width || '100%',
	display: 'grid',
	gridTemplateColumns: 'max-content 1fr',
	color: error
		? theme.palette.error?.main
		: success
		? theme.palette.primary?.main
		: theme.palette.solutions?.[600],
}));
